module.exports = __webpack_public_path__ + "static/media/felicia.830dade7.png";